export const PAGE_PATH = '/welcome-unlogged';
